(function(){
  // Scope check — only run if our root exists
  var root = document.querySelector(".cg-pc-root");
  if (!root) return;

  function getEl(id){ return document.getElementById("cg-pc-" + id); }
  function n(id, fallback){
    var el = getEl(id);
    if (!el) return fallback;
    var v = parseFloat(el.value);
    return isNaN(v) ? fallback : v;
  }
  function fmt(v){
    if (!isFinite(v) || v < 0) v = 0;
    return "$" + Math.round(v).toLocaleString("en-US");
  }
  function fmt2(v){
    if (!isFinite(v) || v < 0) v = 0;
    return "$" + v.toLocaleString("en-US", {minimumFractionDigits:2, maximumFractionDigits:2});
  }
  function fmtHrs(v){
    if (!isFinite(v) || v < 0) v = 0;
    return v.toLocaleString("en-US", {minimumFractionDigits:1, maximumFractionDigits:1}) + " hrs";
  }
  function clearError(){
    ["hours","visits","wage","taxes","overhead","profit"].forEach(function(id){
      var typed = getEl(id);
      var slider = getEl(id + "Slider");
      if (typed) typed.classList.remove("cg-pc-is-flagged");
      if (slider) slider.classList.remove("cg-pc-is-flagged");
    });
  }
  function flagInvalid(ids){
    ids.forEach(function(id){
      var typed = getEl(id);
      var slider = getEl(id + "Slider");
      if (typed) typed.classList.add("cg-pc-is-flagged");
      if (slider) slider.classList.add("cg-pc-is-flagged");
    });
  }
  function calculate(){
    clearError();
    var hours = n("hours", NaN);
    var visits = n("visits", NaN);
    var wage = n("wage", NaN);
    var missing = [];
    if (!isFinite(hours) || hours <= 0) missing.push("hours");
    if (!isFinite(visits) || visits <= 0) missing.push("visits");
    if (!isFinite(wage) || wage <= 0) missing.push("wage");
    if (missing.length){
      flagInvalid(missing);
      var first = getEl(missing[0]);
      if (first) first.focus();
      return;
    }
    var taxes = n("taxes", 0)/100;
    var overhead = n("overhead", 0)/100;
    var profit = n("profit", 0)/100;
    // Guardrail: profit margin must be less than 100%
    if (profit >= 1){
      flagInvalid(["profit"]);
      var pf = getEl("profit");
      if (pf) pf.focus();
      return;
    }
    // CleanGuru formula: payroll taxes & overhead are % of wages only;
    // profit is a margin (share of final price)
    var monthlyHours = hours * visits * 4.33;
    var wages = monthlyHours * wage;
    var taxesAmt = wages * taxes;
    var overheadAmt = wages * overhead;
    var totalCost = wages + taxesAmt + overheadAmt;
    var price = totalCost / (1 - profit);
    var profitAmt = price - totalCost;
    // Populate breakdown rows
    getEl("bdHours").textContent = fmtHrs(monthlyHours);
    getEl("bdWages").textContent = fmt2(wages);
    getEl("bdTaxes").textContent = fmt2(taxesAmt);
    getEl("bdOverhead").textContent = fmt2(overheadAmt);
    getEl("bdTotalCost").textContent = fmt2(totalCost);
    getEl("bdProfit").textContent = fmt2(profitAmt);
    getEl("result").textContent = fmt(price);
    getEl("bdEmpty").classList.add("cg-pc-bd-hidden");
    getEl("bdResult").classList.remove("cg-pc-bd-hidden");
    getEl("resultMsg").classList.remove("cg-pc-bd-hidden");
  }
  function resetAll(){
    var defaults = {hours:0.5, visits:1, wage:8, taxes:0, overhead:0, profit:0};
    Object.keys(defaults).forEach(function(id){
      var typed = getEl(id);
      var slider = getEl(id + "Slider");
      if (typed) typed.value = defaults[id];
      if (slider) slider.value = defaults[id];
    });
    clearError();
    ["bdHours","bdWages","bdTaxes","bdOverhead","bdTotalCost","bdProfit","result"].forEach(function(id){
      var el = getEl(id);
      if (el) el.textContent = "—";
    });
    getEl("bdEmpty").classList.remove("cg-pc-bd-hidden");
    getEl("bdResult").classList.add("cg-pc-bd-hidden");
    getEl("resultMsg").classList.add("cg-pc-bd-hidden");
  }
  var btnCalc = getEl("btnCalculate");
  var btnReset = getEl("btnReset");
  if (btnCalc) btnCalc.addEventListener("click", calculate);
  if (btnReset) btnReset.addEventListener("click", resetAll);
  // Sync slider <-> typed input
  ["hours","visits","wage","taxes","overhead","profit"].forEach(function(id){
    var typed = getEl(id);
    var slider = getEl(id + "Slider");
    if (!typed || !slider) return;
    slider.addEventListener("input", function(){
      typed.value = slider.value;
      typed.classList.remove("cg-pc-is-flagged");
      slider.classList.remove("cg-pc-is-flagged");
    });
    typed.addEventListener("input", function(){
      var v = parseFloat(typed.value);
      if (!isNaN(v)) {
        var min = parseFloat(slider.min);
        var max = parseFloat(slider.max);
        if (v >= min && v <= max) slider.value = v;
        else if (v < min) slider.value = min;
        else slider.value = max;
      }
      typed.classList.remove("cg-pc-is-flagged");
      slider.classList.remove("cg-pc-is-flagged");
    });
    typed.addEventListener("keydown", function(e){
      if (e.key === "Enter"){ e.preventDefault(); calculate(); }
    });
  });
})();
